import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const mindee = defineConnector({
  identifier: "mindee",
  name: "Mindee",
  tagLine: "Document parsing AI",
  logo,
  protocol: "http",
  tags: ["ai", "documents"],
  defaultUrlPattern: () => "https://api\\.mindee\\.net/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your [Mindee](https://platform.mindee.com/) account and copy your API key from the dashboard.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.mindee.net/v1/products",
  },
});
